import React from 'react';
import PropTypes from 'prop-types';
import { Footer as MarketingFooter } from '@storybook/components-marketing';

export const Footer = ({ subscriberCount }) => (
  <MarketingFooter subscriberCount={subscriberCount} />
);

Footer.propTypes = {
  subscriberCount: PropTypes.number.isRequired,
};
